import React from 'react';
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';
import StatItem from '../../../components/StatItem';
import HeroBottle from './HeroBottle';
import './HeroSection.css';

interface Stat {
  number: string;
  label: string;
}

interface HeroSectionProps {
  id?: string;
  badge?: string;
  title: string;
  titleGradient?: string;
  description?: string;
  primaryAction?: {
    label: string;
    to: string;
  };
  secondaryAction?: {
    label: string;
    href: string;
  };
  stats?: Stat[];
}

const HeroSection: React.FC<HeroSectionProps> = ({
  id,
  badge,
  title,
  titleGradient,
  description,
  primaryAction,
  secondaryAction,
  stats = [],
}) => {
  return (
    <section id={id} className="consulting-hero">
      <div className="hero-stage">
        <div className="hero-atmosphere" aria-hidden="true">
          <HeroBottle focusY={0.35} />
        </div>
        <div className="hero-content">
        {badge && <div className="hero-badge">{badge}</div>}
        <h1 className="hero-title">
          {title}
          {titleGradient && <span className="gradient-text">{titleGradient}</span>}
        </h1>
        {description && <p className="hero-description">{description}</p>}
        {(primaryAction || secondaryAction) && (
          <div className="hero-actions">
            {primaryAction && (
              <Button component={Link} to={primaryAction.to} variant="contained" size="large">
                {primaryAction.label}
              </Button>
            )}
            {secondaryAction && (
              <Button component="a" href={secondaryAction.href} variant="outlined" size="large">
                {secondaryAction.label}
              </Button>
            )}
          </div>
        )}
        {stats.length > 0 && (
          <div className="hero-stats">
            {stats.map((stat, index) => (
              <StatItem key={index} number={stat.number} label={stat.label} />
            ))}
          </div>
        )}
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
